export default __webpack_public_path__ + "images/d9cc9eb5431d263d30875ba5a8e310d2.svg";